import { createContext } from 'react';

export interface IAdFoxContextValue {
  onLoad?: () => void;
}

export const AdFoxContext = createContext<IAdFoxContextValue>({});
